function path(root: string, sublink: string) {
  return `${root}/${sublink}`.replace('///', '/').replace('//', '/');
}

const ROOT = '/';
const ROOT_PATH = path(ROOT, '');

export const PATH_AUTH = {
  login: path(ROOT_PATH, 'login'),
  findId: {
    root: path(ROOT_PATH, 'find-id'),
    end: path(ROOT_PATH, 'find-id/end'),
  },
  resetPwd: {
    root: path(ROOT_PATH, 'reset-pwd'),
    form: path(ROOT_PATH, 'reset-pwd/form'),
    end: path(ROOT_PATH, 'reset-pwd/end'),
  },
  register: {
    root: path(ROOT_PATH, 'register'),
    existId: path(ROOT_PATH, 'register/exist-id'),
    form: path(ROOT_PATH, 'register/form'),
    end: path(ROOT_PATH, 'register/end'),
  },
};

export const PATH_PAGE = {
  home: path(ROOT_PATH, '/'),
  page403: path(ROOT_PATH, '403'),
  page404: path(ROOT_PATH, '404'),
  page500: path(ROOT_PATH, '500'),
  patientManagement: {
    root: path(ROOT_PATH, '/patient-management'),
    chart: path(ROOT_PATH, '/patient-management/patient-chart/:userSid'),
    diary: path(ROOT_PATH, '/patient-management/patient-diary/:userSid'),
  },
  scenarioManagement: path(ROOT_PATH, '/scenario-management'),
  serviceControl: path(ROOT_PATH, '/service-control'),
  termsManagement: path(ROOT_PATH, '/terms-management'),
  hospitalManagement: path(ROOT_PATH, '/hospital-management'),
  myPage: {
    profileManagement: path(ROOT_PATH, 'profile-management'),
    changePassword: path(ROOT_PATH, 'change-password'),
    changeLanguage: path(ROOT_PATH, 'change-language'),
    memberWithdrawal: path(ROOT_PATH, 'member-withdrawal'),
  },
};
